webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = exports.lan = exports.getParam = exports.transform = exports.lastRecord = exports.StorageKey = exports.maxPoint = exports.SCORE_PER_FOOD = exports.eachFoods = exports.speeds = exports.DIR = exports.ROWS = exports.COLS = undefined;

var _i18n = __webpack_require__(162);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLS = exports.COLS = 10;
var ROWS = exports.ROWS = 20;

var DIR = exports.DIR = {
  UP: { x: 0, y: -1 },
  DOWN: { x: 0, y: 1 },
  LEFT: { x: -1, y: 0 },
  RIGHT: { x: 1, y: 0 }
};

var speeds = exports.speeds = [200, 160, 130, 100, 75, 55];

var eachFoods = exports.eachFoods = 5;

var SCORE_PER_FOOD = exports.SCORE_PER_FOOD = 10;
var maxPoint = exports.maxPoint = 999999;

var StorageKey = exports.StorageKey = 'VUE_SNAKE';

var lastRecord = exports.lastRecord = function () {
  var data = window.localStorage.getItem(StorageKey);
  if (!data) return false;
  try {
    if (window.btoa) data = atob(data);
    data = decodeURIComponent(data);
    data = JSON.parse(data);
  } catch (e) {
    if (window.console || window.console.error) {
      window.console.error('读取记录错误:', e);
    }
    return false;
  }
  return data;
}();

var transform = exports.transform = function () {
  var trans = ['transform', 'webkitTransform', 'msTransform', 'mozTransform', 'oTransform'];
  var body = document.body;
  return trans.filter(function (e) {
    return body.style[e] !== undefined;
  })[0];
}();

var getParam = exports.getParam = function getParam(param) {
  var r = new RegExp('\\?(?:.+&)?' + param + '=(.*?)(?:&.*)?$');
  var m = window.location.toString().match(r);
  return m ? decodeURI(m[1]) : '';
};

var lan = exports.lan = function () {
  var l = getParam('lan').toLowerCase();
  if (!l && navigator.languages) {
    l = navigator.languages.find(function (l) {
      return _i18n2.default.lan.indexOf(l) !== -1;
    });
  }
  l = _i18n2.default.lan.indexOf(l) === -1 ? _i18n2.default.default : l;
  return l;
}();

document.title = _i18n2.default.data.title[lan];

var i18n = exports.i18n = _i18n2.default.data;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _store = __webpack_require__(15);

var _store2 = _interopRequireDefault(_store);

var _snake = __webpack_require__(16);

var _const = __webpack_require__(0);

var _music = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var states = {
  tickInterval: null,
  overTimeout: null,

  resetToReady: function resetToReady() {
    clearTimeout(states.tickInterval);
    clearTimeout(states.overTimeout);
    _store2.default.commit('snake', null);
    _store2.default.commit('food', null);
    _store2.default.commit('matrix', []);
    _store2.default.commit('status', 'ready');
    _store2.default.commit('reset', false);
    _store2.default.commit('lock', false);
    _store2.default.commit('points', 0);
    _store2.default.commit('foodCount', 0);
  },
  start: function start() {
    if (_music.music.start) _music.music.start();
    clearTimeout(states.tickInterval);
    clearTimeout(states.overTimeout);
    var state = _store2.default.state;
    var snake = (0, _snake.createSnake)();
    var food = (0, _snake.spawnFood)(snake);
    _store2.default.commit('snake', snake);
    _store2.default.commit('food', food);
    _store2.default.commit('speedRun', state.speedStart);
    _store2.default.commit('points', 0);
    _store2.default.commit('foodCount', 0);
    _store2.default.commit('status', 'playing');
    _store2.default.commit('lock', false);
    _store2.default.commit('pause', false);
    _store2.default.commit('reset', false);
    _store2.default.commit('matrix', (0, _snake.toMatrix)(snake, food));
    states.auto();
  },
  auto: function auto(timeout) {
    var out = timeout < 0 ? 0 : timeout;
    var tick = function tick() {
      var state = _store2.default.state;
      if (state.status !== 'playing' || state.pause) return;
      var result = (0, _snake.step)(state.snake, state.food, state.wallPass);
      _store2.default.commit('snake', result.snake);

      if (result.event === 'dead') {
        _store2.default.commit('matrix', (0, _snake.toMatrix)(result.snake, state.food));
        states.overStart(true);
        return;
      }

      if (result.event === 'eat') {
        if (_music.music.eat) _music.music.eat();
        var newPoints = state.points + _const.SCORE_PER_FOOD;
        _store2.default.commit('points', newPoints);
        _store2.default.commit('foodCount', state.foodCount + 1);
        if (newPoints > state.max) _store2.default.commit('max', newPoints);

        if (state.foodCount % _const.eachFoods === 0 && state.speedRun < 5) {
          _store2.default.commit('speedRun', state.speedRun + 1);
        }
        var newFood = (0, _snake.spawnFood)(result.snake);
        _store2.default.commit('food', newFood);
      }

      if (result.event === 'move') {
        if (_music.music.move) _music.music.move();
      }

      _store2.default.commit('matrix', (0, _snake.toMatrix)(_store2.default.state.snake, _store2.default.state.food));

      clearTimeout(states.tickInterval);
      states.tickInterval = setTimeout(tick, _const.speeds[_store2.default.state.speedRun]);
    };

    clearTimeout(states.tickInterval);
    states.tickInterval = setTimeout(tick, out === undefined ? _const.speeds[_store2.default.state.speedRun] : out);
  },
  pause: function pause(isPause) {
    _store2.default.commit('pause', isPause);
    if (isPause) {
      clearTimeout(states.tickInterval);return;
    }
    if (_store2.default.state.status === 'playing') states.auto();
  },
  focus: function focus(isFocus) {
    _store2.default.commit('focus', isFocus);
    if (!isFocus) {
      clearTimeout(states.tickInterval);return;
    }
    var state = _store2.default.state;
    if (state.status === 'playing' && !state.pause && !state.reset) states.auto();
  },
  entranceAnimation: function entranceAnimation() {
    clearTimeout(states.overTimeout);
    _store2.default.commit('reset', true);
    var COLS = 10,
        ROWS = 20;
    var newMatrix = [];
    for (var y = 0; y < ROWS; y++) {
      var _row = [];
      for (var x = 0; x < COLS; x++) {
        _row.push(0);
      }newMatrix.push(_row);
    }
    _store2.default.commit('matrix', JSON.parse((0, _stringify2.default)(newMatrix)));
    var row = ROWS - 1;
    var fillUp = function fillUp() {
      if (row < 0) {
        states.overTimeout = setTimeout(function () {
          var clearRow = 0;
          var clearDown = function clearDown() {
            if (clearRow >= ROWS) {
              states.overTimeout = setTimeout(function () {
                _store2.default.commit('reset', false);
              }, 200);
              return;
            }
            for (var _x = 0; _x < COLS; _x++) {
              newMatrix[clearRow][_x] = 0;
            }
            _store2.default.commit('matrix', JSON.parse((0, _stringify2.default)(newMatrix)));
            clearRow++;
            states.overTimeout = setTimeout(clearDown, 40);
          };
          clearDown();
        }, 400);
        return;
      }
      for (var _x2 = 0; _x2 < COLS; _x2++) {
        newMatrix[row][_x2] = 1;
      }
      _store2.default.commit('matrix', JSON.parse((0, _stringify2.default)(newMatrix)));
      row--;
      states.overTimeout = setTimeout(fillUp, 50);
    };
    fillUp();
  },
  overStart: function overStart(shouldSubmit) {
    clearTimeout(states.tickInterval);
    clearTimeout(states.overTimeout);
    _store2.default.commit('snake', null);
    _store2.default.commit('food', null);
    _store2.default.commit('reset', true);
    _store2.default.commit('status', 'gameover');
    _store2.default.commit('pause', false);

    if (_music.music.death) _music.music.death();

    if (shouldSubmit) {
      var finalPoints = _store2.default.state.points;
      if (finalPoints > 0) {
        var trySubmit = function trySubmit(retries) {
          if (window.GamePlatform && typeof window.GamePlatform.submitScore === 'function') {
            window.GamePlatform.submitScore('greedy-snake', finalPoints).then(function () {
              console.log('[greedy-snake] score submitted:', finalPoints);
            }).catch(function (e) {
              console.warn('[greedy-snake] submitScore failed:', e && e.message);
            });
          } else if (retries > 0) {
            setTimeout(function () {
              return trySubmit(retries - 1);
            }, 1000);
          }
        };
        trySubmit(5);
      }
    }

    var baseMatrix = _store2.default.state.matrix.length ? _store2.default.state.matrix : [];
    var newMatrix = [];
    for (var y = 0; y < _const.ROWS; y++) {
      var _row2 = [];
      for (var x = 0; x < _const.COLS; x++) {
        _row2.push(baseMatrix[y] ? baseMatrix[y][x] || 0 : 0);
      }
      newMatrix.push(_row2);
    }
    var row = _const.ROWS - 1;
    var fillUp = function fillUp() {
      if (row < 0) {
        states.overTimeout = setTimeout(function () {
          var clearRow = 0;
          var clearDown = function clearDown() {
            if (clearRow >= _const.ROWS) {
              states.overTimeout = setTimeout(function () {
                return states.overEnd();
              }, 300);
              return;
            }
            for (var _x3 = 0; _x3 < _const.COLS; _x3++) {
              newMatrix[clearRow][_x3] = 0;
            }
            _store2.default.commit('matrix', JSON.parse((0, _stringify2.default)(newMatrix)));
            clearRow++;
            states.overTimeout = setTimeout(clearDown, 40);
          };
          clearDown();
        }, 400);
        return;
      }
      for (var _x4 = 0; _x4 < _const.COLS; _x4++) {
        newMatrix[row][_x4] = 1;
      }
      _store2.default.commit('matrix', JSON.parse((0, _stringify2.default)(newMatrix)));
      row--;
      states.overTimeout = setTimeout(fillUp, 50);
    };
    fillUp();
  },
  overEnd: function overEnd() {
    clearTimeout(states.tickInterval);
    clearTimeout(states.overTimeout);
    _store2.default.commit('snake', null);
    _store2.default.commit('food', null);
    var emptyMatrix = [];
    for (var y = 0; y < _const.ROWS; y++) {
      var row = [];
      for (var x = 0; x < _const.COLS; x++) {
        row.push(0);
      }emptyMatrix.push(row);
    }
    _store2.default.commit('matrix', emptyMatrix);
    _store2.default.commit('status', 'ready');
    _store2.default.commit('reset', false);
    _store2.default.commit('lock', false);
    _store2.default.commit('points', 0);
    _store2.default.commit('foodCount', 0);
  }
};

exports.default = states;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(40);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventName = {};
var eventFired = {};

var down = function down(o) {
  if (o.once && eventFired[o.key]) return;

  var keys = (0, _keys2.default)(eventName);
  keys.forEach(function (i) {
    clearTimeout(eventName[i]);
    eventName[i] = null;
  });
  if (!o.callback) return;
  var clear = function clear() {
    clearTimeout(eventName[o.key]);
  };
  o.callback(clear);

  if (o.once === true) {
    eventFired[o.key] = true;
    return;
  }
  var begin = o.begin || 100;
  var interval = o.interval || 50;
  var loop = function loop() {
    eventName[o.key] = setTimeout(function () {
      begin = null;
      loop();
      o.callback(clear);
    }, begin || interval);
  };
  loop();
};

var up = function up(o) {
  clearTimeout(eventName[o.key]);
  eventName[o.key] = null;
  eventFired[o.key] = false;
  if (!o.callback) return;
  o.callback();
};

var clearAll = function clearAll() {
  var keys = (0, _keys2.default)(eventName);
  keys.forEach(function (i) {
    clearTimeout(eventName[i]);
    eventName[i] = null;
  });
};

exports.default = { down: down, up: up, clearAll: clearAll };

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.music = exports.hasWebAudioAPI = undefined;

var _store = __webpack_require__(15);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext;

var hasWebAudioAPI = exports.hasWebAudioAPI = {
  data: !!AudioContext && location.protocol.indexOf('http') !== -1
};

var music = exports.music = {};(function () {
  if (!hasWebAudioAPI.data) return;
  var url = './static/music.mp3';
  var context = new AudioContext();
  var req = new XMLHttpRequest();
  req.open('GET', url, true);
  req.responseType = 'arraybuffer';

  req.onload = function () {
    context.decodeAudioData(req.response, function (buf) {
      var getSource = function getSource() {
        var source = context.createBufferSource();
        source.buffer = buf;
        source.connect(context.destination);
        return source;
      };

      music.killStart = function () {
        music.start = function () {};
      };

      music.start = function () {
        music.killStart();
        if (!_store2.default.state.music) return;
        getSource().start(0, 3.7202, 3.6224);
      };

      music.eat = function () {
        if (!_store2.default.state.music) return;
        getSource().start(0, 0, 0.7675);
      };

      music.death = function () {
        if (!_store2.default.state.music) return;
        getSource().start(0, 8.1276, 1.1437);
      };

      music.move = function () {
        if (!_store2.default.state.music) return;
        getSource().start(0, 2.9088, 0.1437);
      };
    }, function (error) {
      if (window.console && window.console.error) {
        window.console.error('\u97F3\u9891: ' + url + ' \u8BFB\u53D6\u9519\u8BEF', error);
        hasWebAudioAPI.data = false;
      }
    });
  };

  req.send();
})();

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(37);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(59);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(80);

var _mutations2 = _interopRequireDefault(_mutations);

var _unit = __webpack_require__(21);

var _const = __webpack_require__(0);

var _music = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var musicInitState = _const.lastRecord && _const.lastRecord.music !== undefined ? !!_const.lastRecord.music : true;
if (!_music.hasWebAudioAPI.data) musicInitState = false;

var maxInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.max, 10)) ? parseInt(_const.lastRecord.max, 10) : 0;
if (maxInitState < 0) maxInitState = 0;else if (maxInitState > _const.maxPoint) maxInitState = _const.maxPoint;

var pointsInitState = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.points, 10)) ? parseInt(_const.lastRecord.points, 10) : 0;
if (pointsInitState < 0) pointsInitState = 0;else if (pointsInitState > _const.maxPoint) pointsInitState = _const.maxPoint;

var speedStartInit = _const.lastRecord && !isNaN(parseInt(_const.lastRecord.speedStart, 10)) ? parseInt(_const.lastRecord.speedStart, 10) : 1;
if (speedStartInit < 0) speedStartInit = 0;
if (speedStartInit > 5) speedStartInit = 5;

var wallPassInitState = _const.lastRecord && _const.lastRecord.wallPass !== undefined ? !!_const.lastRecord.wallPass : false;

var lockInitState = _const.lastRecord && _const.lastRecord.lock !== undefined ? !!_const.lastRecord.lock : false;
var pauseInitState = _const.lastRecord && _const.lastRecord.pause !== undefined ? !!_const.lastRecord.pause : false;
var resetInitState = _const.lastRecord && _const.lastRecord.reset ? !!_const.lastRecord.reset : false;

var state = {
  snake: null,
  food: null,
  wallPass: wallPassInitState,
  matrix: function () {
    var m = [];
    for (var y = 0; y < 20; y++) {
      var row = [];
      for (var x = 0; x < 10; x++) {
        row.push(0);
      }m.push(row);
    }
    return m;
  }(),

  status: 'ready',
  speedStart: speedStartInit,
  speedRun: speedStartInit,
  foodCount: 0,

  points: pointsInitState,
  max: maxInitState,

  music: musicInitState,
  pause: pauseInitState,
  reset: resetInitState,
  lock: lockInitState,
  focus: (0, _unit.isFocus)(),
  keyboard: { up: false, down: false, left: false, right: false, reset: false, music: false, pause: false }
};

exports.default = new _vuex2.default.Store({ state: state, mutations: _mutations2.default });

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(36);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = __webpack_require__(83);

var _set2 = _interopRequireDefault(_set);

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

exports.createSnake = createSnake;
exports.setDirection = setDirection;
exports.spawnFood = spawnFood;
exports.step = step;
exports.toMatrix = toMatrix;

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INIT_LEN = 3;

function createSnake() {
  var startX = Math.max(1, Math.floor(_const.COLS / 4));
  var startY = Math.floor(_const.ROWS / 2);
  var body = [];
  for (var i = 0; i < INIT_LEN; i++) {
    body.push({ x: startX + (INIT_LEN - 1 - i), y: startY });
  }
  return {
    body: body,
    direction: _const.DIR.RIGHT,
    nextDirection: _const.DIR.RIGHT
  };
}

function setDirection(snake, dir) {
  var cur = snake.direction;
  if (cur.x + dir.x === 0 && cur.y + dir.y === 0) {
    return snake;
  }
  return (0, _extends3.default)({}, snake, { nextDirection: dir });
}

function spawnFood(snake) {
  var body = snake.body;
  var occupied = new _set2.default(body.map(function (p) {
    return p.x + ',' + p.y;
  }));
  var empty = [];
  for (var x = 0; x < _const.COLS; x++) {
    for (var y = 0; y < _const.ROWS; y++) {
      if (!occupied.has(x + ',' + y)) {
        empty.push({ x: x, y: y });
      }
    }
  }
  if (empty.length === 0) return null;
  return empty[Math.floor(Math.random() * empty.length)];
}

function step(snake, food, wallPass) {
  var dir = snake.nextDirection;
  var head = snake.body[0];
  var newX = head.x + dir.x;
  var newY = head.y + dir.y;

  if (wallPass) {
    if (newX < 0) newX = _const.COLS - 1;
    if (newX >= _const.COLS) newX = 0;
    if (newY < 0) newY = _const.ROWS - 1;
    if (newY >= _const.ROWS) newY = 0;
  } else {
    if (newX < 0 || newX >= _const.COLS || newY < 0 || newY >= _const.ROWS) {
      return { snake: (0, _extends3.default)({}, snake, { direction: dir }), food: food, event: 'dead' };
    }
  }

  for (var i = 0; i < snake.body.length - 1; i++) {
    if (snake.body[i].x === newX && snake.body[i].y === newY) {
      return { snake: (0, _extends3.default)({}, snake, { direction: dir }), food: food, event: 'dead' };
    }
  }

  var newHead = { x: newX, y: newY };
  var eating = food && newX === food.x && newY === food.y;
  var newBody = [newHead].concat((0, _toConsumableArray3.default)(snake.body));
  if (!eating) newBody.pop();

  return {
    snake: { body: newBody, direction: dir, nextDirection: dir },
    food: eating ? null : food,
    event: eating ? 'eat' : 'move'
  };
}

function toMatrix(snake, food) {
  var matrix = [];
  for (var y = 0; y < _const.ROWS; y++) {
    var row = [];
    for (var x = 0; x < _const.COLS; x++) {
      row.push(0);
    }
    matrix.push(row);
  }
  if (food) {
    matrix[food.y][food.x] = 2;
  }
  if (snake && snake.body) {
    snake.body.forEach(function (seg) {
      matrix[seg.y][seg.x] = 1;
    });
  }
  return matrix;
}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFocus = exports.visibilityChangeEvent = exports.isMobile = exports.subscribeRecord = undefined;

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hiddenProperty = function () {
  var names = ['hidden', 'webkitHidden', 'mozHidden', 'msHidden'];
  names = names.filter(function (e) {
    return e in document;
  });
  return names.length > 0 ? names[0] : false;
}();

var unit = {
  subscribeRecord: function subscribeRecord(store) {
    store.subscribe(function () {
      var data = store.state;
      if (data.lock) return;
      data = (0, _stringify2.default)(data);
      data = encodeURIComponent(data);
      if (window.btoa) data = btoa(data);
      window.localStorage.setItem(_const.StorageKey, data);
    });
  },
  isMobile: function isMobile() {
    var ua = navigator.userAgent;
    var android = /Android (\d+\.\d+)/.test(ua);
    var iphone = ua.indexOf('iPhone') > -1;
    var ipod = ua.indexOf('iPod') > -1;
    var ipad = ua.indexOf('iPad') > -1;
    var nokiaN = ua.indexOf('NokiaN') > -1;
    return android || iphone || ipod || ipad || nokiaN;
  },

  visibilityChangeEvent: function () {
    if (!hiddenProperty) return false;
    return hiddenProperty.replace(/hidden/i, 'visibilitychange');
  }(),
  isFocus: function isFocus() {
    if (!hiddenProperty) return true;
    return !document[hiddenProperty];
  }
};

var subscribeRecord = unit.subscribeRecord,
    isMobile = unit.isMobile,
    visibilityChangeEvent = unit.visibilityChangeEvent,
    isFocus = unit.isFocus;
exports.subscribeRecord = subscribeRecord;
exports.isMobile = isMobile;
exports.visibilityChangeEvent = visibilityChangeEvent;
exports.isFocus = isFocus;

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _left = __webpack_require__(74);

var _left2 = _interopRequireDefault(_left);

var _right = __webpack_require__(77);

var _right2 = _interopRequireDefault(_right);

var _up = __webpack_require__(78);

var _up2 = _interopRequireDefault(_up);

var _down = __webpack_require__(73);

var _down2 = _interopRequireDefault(_down);

var _p = __webpack_require__(75);

var _p2 = _interopRequireDefault(_p);

var _r = __webpack_require__(76);

var _r2 = _interopRequireDefault(_r);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { left: _left2.default, down: _down2.default, up: _up2.default, right: _right2.default, p: _p2.default, r: _r2.default };

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(159),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(40);

var _keys2 = _interopRequireDefault(_keys);

var _store = __webpack_require__(15);

var _store2 = _interopRequireDefault(_store);

var _todo = __webpack_require__(38);

var _todo2 = _interopRequireDefault(_todo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyboard = {
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
  87: 'up',
  65: 'left',
  83: 'down',
  68: 'right',
  32: 'pause',
  80: 'p',
  82: 'r' };

var keydownActive = void 0;

var boardKeys = (0, _keys2.default)(keyboard).map(function (e) {
  return parseInt(e, 10);
});

var keyDown = function keyDown(e) {
  if (e.metaKey === true || boardKeys.indexOf(e.keyCode) === -1) return;
  var type = keyboard[e.keyCode];
  if (type === keydownActive) return;
  keydownActive = type;
  _todo2.default[type].down(_store2.default);
};

var keyUp = function keyUp(e) {
  if (e.metaKey === true || boardKeys.indexOf(e.keyCode) === -1) return;
  var type = keyboard[e.keyCode];
  if (type === keydownActive) keydownActive = '';
  _todo2.default[type].up(_store2.default);
};

document.addEventListener('keydown', keyDown, true);
document.addEventListener('keyup', keyUp, true);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['propMatrix']
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(41);

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__(141);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(142);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(147);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(148);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(58);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(149);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(144);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(146);

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__(145);

var _index18 = _interopRequireDefault(_index17);

var _vuex = __webpack_require__(59);

var _const = __webpack_require__(0);

var _unit = __webpack_require__(21);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    this.render();
    window.addEventListener('resize', this.resize.bind(this), true);
  },
  data: function data() {
    return {
      size: {},
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
      filling: ''
    };
  },

  components: { Decorate: _index2.default, Guide: _index4.default, Music: _index6.default, Pause: _index8.default, Number: _index10.default, Point: _index12.default, Keyboard: _index14.default, Matrix: _index16.default, Logo: _index18.default },
  computed: (0, _extends3.default)({
    foodLabel: function foodLabel() {
      return _const.i18n.foodCount[_const.lan];
    },
    levelLabel: function levelLabel() {
      return _const.i18n.level[_const.lan];
    },
    wallPassLabel: function wallPassLabel() {
      return _const.i18n.wallPass[_const.lan];
    }
  }, (0, _vuex.mapState)(['matrix', 'wallPass', 'status', 'speedRun', 'points', 'max', 'reset', 'pause', 'music', 'keyboard', 'foodCount'])),
  methods: {
    render: function render() {
      var _this = this;

      var filling = 0;
      var size = function () {
        var w = _this.w,
            h = _this.h,
            ratio = h / w;
        var scale = void 0,
            css = {};
        if (ratio < 1.5) {
          scale = h / 960;
        } else {
          scale = w / 640;
          filling = (h - 960 * scale) / scale / 3;
          css = {
            'padding-top': Math.floor(filling) + 42 + 'px',
            'padding-bottom': Math.floor(filling) + 'px',
            'margin-top': Math.floor(-480 - filling * 1.5) + 'px'
          };
        }
        css[_const.transform] = 'scale(' + scale + ')';
        return css;
      }();
      this.size = size;
      this.start();
      this.filling = filling;
    },
    resize: function resize() {
      this.w = document.documentElement.clientWidth;
      this.h = document.documentElement.clientHeight;
      this.render();
    },
    start: function start() {
      if (_unit.visibilityChangeEvent) {
        document.addEventListener(_unit.visibilityChangeEvent, function () {
          _states2.default.focus((0, _unit.isFocus)());
        }, false);
      }

      if (_const.lastRecord) {
        if (_const.lastRecord.snake && !_const.lastRecord.pause) {
          var speedRun = this.$store.state.speedRun;
          var timeout = _const.speeds[speedRun] / 2;
          _states2.default.auto(timeout);
        }
        if (!_const.lastRecord.snake) {
          _states2.default.entranceAnimation();
        }
      } else {
        _states2.default.entranceAnimation();
      }
    }
  }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

exports.default = {
  name: 'Decorate',
  computed: {
    title: function title() {
      return _const.i18n.title[_const.lan];
    },
    github: function github() {
      return _const.i18n.github[_const.lan];
    },
    QRTitle: function QRTitle() {
      return _const.i18n.QRNotice[_const.lan];
    },
    QRCode: function QRCode() {
      return _const.i18n.QRCode[_const.lan];
    }
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var _unit = __webpack_require__(21);

exports.default = {
  name: 'Guide',
  data: function data() {
    return {
      isMobile: (0, _unit.isMobile)()
    };
  },

  computed: {
    linkTitle: function linkTitle() {
      return _const.i18n.linkTitle[_const.lan];
    },
    github: function github() {
      return _const.i18n.github[_const.lan];
    },
    QRCode: function QRCode() {
      return _const.i18n.QRCode[_const.lan];
    },
    QRTitle: function QRTitle() {
      return _const.i18n.QRNotice[_const.lan];
    },
    QRSrc: function QRSrc() {
      return window.location.protocol + '//raw.githubusercontent.com/Binaryify/vue-tetris/master/static/qr.jpeg';
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.resize.bind(this), true);
  },

  methods: {
    resize: function resize() {
      this.isMobile = (0, _unit.isMobile)();
    }
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

exports.default = {
  props: ['active', 'color', 'size', 'top', 'left', 'label', 'position', 'arrow']
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(143);

var _index2 = _interopRequireDefault(_index);

var _const = __webpack_require__(0);

var _store = __webpack_require__(15);

var _store2 = _interopRequireDefault(_store);

var _todo = __webpack_require__(38);

var _todo2 = _interopRequireDefault(_todo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fired = {};

exports.default = {
  props: ['filling', 'wallPass', 'difficulty'],
  data: function data() {
    return { fillingNum: 0 };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.fillingNum = nextProps.filling + 20;
      }
    }
  },
  computed: {
    keyboard: function keyboard() {
      return this.$store.state.keyboard;
    },

    labelUp: function labelUp() {
      return _const.i18n.rotation[_const.lan];
    },
    labelLeft: function labelLeft() {
      return _const.i18n.left[_const.lan];
    },
    labelRight: function labelRight() {
      return _const.i18n.right[_const.lan];
    },
    labelDown: function labelDown() {
      return _const.i18n.down[_const.lan];
    },
    labelResetR: function labelResetR() {
      return _const.i18n.reset[_const.lan] + '(R)';
    },
    labelSoundS: function labelSoundS() {
      return _const.i18n.sound[_const.lan] + '(S)';
    },
    labelPauseP: function labelPauseP() {
      return _const.i18n.pause[_const.lan] + '(P)';
    }
  },
  methods: {
    onUpStart: function onUpStart(e) {
      if (e) e.preventDefault();
      if (fired.up) return;fired.up = true;
      _store2.default.commit('key_up', true);
      _todo2.default.up.down(_store2.default);
    },
    onUpEnd: function onUpEnd() {
      fired.up = false;_store2.default.commit('key_up', false);_todo2.default.up.up(_store2.default);
    },
    onDownStart: function onDownStart(e) {
      if (e) e.preventDefault();
      if (fired.down) return;fired.down = true;
      _store2.default.commit('key_down', true);
      _todo2.default.down.down(_store2.default);
    },
    onDownEnd: function onDownEnd() {
      fired.down = false;_store2.default.commit('key_down', false);_todo2.default.down.up(_store2.default);
    },
    onLeftStart: function onLeftStart(e) {
      if (e) e.preventDefault();
      if (fired.left) return;fired.left = true;
      _store2.default.commit('key_left', true);
      _todo2.default.left.down(_store2.default);
    },
    onLeftEnd: function onLeftEnd() {
      fired.left = false;_store2.default.commit('key_left', false);_todo2.default.left.up(_store2.default);
    },
    onRightStart: function onRightStart(e) {
      if (e) e.preventDefault();
      if (fired.right) return;fired.right = true;
      _store2.default.commit('key_right', true);
      _todo2.default.right.down(_store2.default);
    },
    onRightEnd: function onRightEnd() {
      fired.right = false;_store2.default.commit('key_right', false);_todo2.default.right.up(_store2.default);
    },
    onResetDown: function onResetDown(e) {
      if (e) e.preventDefault();
      _store2.default.commit('key_reset', true);
      _todo2.default.r.down(_store2.default);
    },
    onResetUp: function onResetUp() {
      _store2.default.commit('key_reset', false);
      _todo2.default.r.up(_store2.default);
    },
    onPauseDown: function onPauseDown(e) {
      if (e) e.preventDefault();
      _store2.default.commit('key_pause', true);
      _todo2.default.p.down(_store2.default);
    },
    onPauseUp: function onPauseUp() {
      _store2.default.commit('key_pause', false);
      _todo2.default.p.up(_store2.default);
    },
    onGoDown: function onGoDown(e) {
      if (e) e.preventDefault();
    },
    onGoUp: function onGoUp() {},
    onMusicDown: function onMusicDown(e) {
      if (e) e.preventDefault();
      if (_store2.default.state.lock) return;
      _store2.default.commit('music', !_store2.default.state.music);
      _store2.default.commit('key_music', true);
    },
    onMusicUp: function onMusicUp() {
      _store2.default.commit('key_music', false);
    }
  },
  components: { Vbutton: _index2.default }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var Logo = {
  timeout: null
};
exports.default = {
  props: ['cur', 'reset'],
  data: function data() {
    return {
      style: 'r1',
      display: 'none'
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps, oldProps) {
        this.animate(nextProps);
        if ([oldProps.cur, nextProps.cur].indexOf(false) !== -1 && oldProps.cur !== nextProps.cur || oldProps.reset !== nextProps.reset) {
          this.animate(nextProps);
        }
      }
    }
  },
  computed: {
    titleCenter: function titleCenter() {
      return _const.i18n.titleCenter[_const.lan];
    }
  },
  beforeMount: function beforeMount() {
    this.animate(this.$props);
  },

  methods: {
    animate: function animate(_ref) {
      var _this = this;

      var cur = _ref.cur,
          reset = _ref.reset;

      clearTimeout(Logo.timeout);
      this.style = 'r1';
      this.display = 'none';
      if (cur || reset) {
        this.display = 'none';
        return;
      }

      var m = 'r';
      var count = 0;

      var set = function set(func, delay) {
        if (!func) {
          return;
        }
        Logo.timeout = setTimeout(func, delay);
      };

      var show = function show(func) {
        set(function () {
          _this.display = 'block';
          if (func) {
            func();
          }
        }, 150);
      };

      var hide = function hide(func) {
        set(function () {
          _this.display = 'none';
          if (func) {
            func();
          }
        }, 150);
      };

      var eyes = function eyes(func, delay1, delay2) {
        set(function () {
          _this.style = m + 2;
          set(function () {
            _this.style = m + 1;
            if (func) {
              func();
            }
          }, delay2);
        }, delay1);
      };

      var run = function run(func) {
        set(function () {
          _this.style = m + 4;
          set(function () {
            _this.style = m + 3;
            count++;
            if (count === 10 || count === 20 || count === 30) {
              m = m === 'r' ? 'l' : 'r';
            }
            if (count < 40) {
              run(func);
              return;
            }
            _this.style = m + 1;
            if (func) {
              set(func, 4000);
            }
          }, 100);
        }, 100);
      };

      var dra = function dra() {
        count = 0;
        eyes(function () {
          eyes(function () {
            eyes(function () {
              _this.style = m + 2;
              run(dra);
            }, 150, 150);
          }, 150, 150);
        }, 1000, 1500);
      };

      show(function () {
        hide(function () {
          show(function () {
            hide(function () {
              show(function () {
                dra();
              });
            });
          });
        });
      });
    }
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['data']
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var formate = function formate(num) {
  return num < 10 ? ('0' + num).split('') : ('' + num).split('');
};
var NumberObj = {
  timeInterval: null,
  time_count: null
};
exports.default = {
  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.render();
      }
    }
  },
  props: {
    propTime: {
      type: Boolean
    },
    number: {
      type: Number
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      time_count: '',
      time: new Date(),
      data: []
    };
  },
  destroyed: function destroyed() {
    if (!this.propTime) {
      return;
    }
    clearTimeout(NumberObj.timeInterval);
  },

  methods: {
    render: function render() {
      if (this.propTime) {
        var now = this.time;
        var hour = formate(now.getHours());
        var min = formate(now.getMinutes());
        var sec = now.getSeconds() % 2;
        var t = hour.concat(sec ? 'd' : 'd_c', min);
        this.data = t;
        return;
      }
      var num = ('' + this.number).split('');
      for (var i = 0, len = this.length - num.length; i < len; i++) {
        num.unshift('n');
      }
      this.data = num;
      return;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.length) {
      this.length = 6;
    }
    if (!this.propTime) {
      return;
    }
    var clock = function clock() {
      var count = +NumberObj.timeInterval;
      NumberObj.timeInterval = setTimeout(function () {
        _this.time = new Date();
        _this.time_count = count;
        _this.render();
        clock();
      }, 1000);
    };
    clock();
  },
  mounted: function mounted() {
    this.render();
  }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Pause = {
  timeout: null
};
exports.default = {
  props: ['data'],
  mounted: function mounted() {
    this.setShake(this.data);
  },
  data: function data() {
    return {
      showPause: false
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.setShake(nextProps.data);
      }
    }
  },
  methods: {
    setShake: function setShake(bool) {
      var _this = this;

      if (bool && !Pause.timeout) {
        Pause.timeout = setInterval(function () {
          _this.showPause = !_this.showPause;
        }, 250);
      }
      if (!bool && Pause.timeout) {
        clearInterval(Pause.timeout);
        this.showPause = false;
        Pause.timeout = null;
      }
    }
  }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var _index = __webpack_require__(58);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DF = _const.i18n.point[_const.lan];
var ZDF = _const.i18n.highestScore[_const.lan];
var SLDF = _const.i18n.lastRound[_const.lan];
var Point = {
  timeout: null
};
exports.default = {
  props: ['cur', 'point', 'max'],
  mounted: function mounted() {
    this.onChange(this.$props);
  },

  components: {
    Number: _index2.default
  },
  data: function data() {
    return {
      label: '',
      number: 0
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.onChange(nextProps);
      }
    }
  },
  methods: {
    onChange: function onChange(_ref) {
      var _this = this;

      var cur = _ref.cur,
          point = _ref.point,
          max = _ref.max;

      clearInterval(Point.timeout);
      if (cur) {
        this.label = point >= max ? ZDF : DF;
        this.number = point;
      } else {
        var toggle = function toggle() {
          _this.label = SLDF;
          _this.number = point;
          Point.timeout = setTimeout(function () {
            _this.label = ZDF;
            _this.number = max;
            Point.timeout = setTimeout(toggle, 3000);
          }, 3000);
        };

        if (point !== 0) {
          toggle();
        } else {
          this.label = ZDF;
          this.number = max;
        }
      }
    }
  }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _snake = __webpack_require__(16);

var _event = __webpack_require__(11);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(12);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var downFn = function downFn(store) {
  store.commit('key_down', true);
  _event2.default.down({
    key: 'down',
    begin: 150,
    interval: 80,
    callback: function callback() {
      var state = store.state;
      if (state.lock) return;
      if (state.snake && state.status === 'playing') {
        if (state.pause) {
          _states2.default.pause(false);return;
        }
        if (_music.music.move) _music.music.move();
        store.commit('snake', (0, _snake.setDirection)(state.snake, _const.DIR.DOWN));
      } else {
        store.commit('wallPass', !state.wallPass);
      }
    }
  });
};

var upFn = function upFn(store) {
  store.commit('key_down', false);
  _event2.default.up({ key: 'down' });
};

exports.default = { down: downFn, up: upFn };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _snake = __webpack_require__(16);

var _event = __webpack_require__(11);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(12);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_left', true);
  _event2.default.down({
    key: 'left',
    begin: 150,
    interval: 80,
    callback: function callback() {
      var state = store.state;
      if (state.lock) return;
      if (state.snake && state.status === 'playing') {
        if (state.pause) {
          _states2.default.pause(false);return;
        }
        if (_music.music.move) _music.music.move();
        store.commit('snake', (0, _snake.setDirection)(state.snake, _const.DIR.LEFT));
      } else {
        var next = state.speedStart === 0 ? 5 : state.speedStart - 1;
        store.commit('speedStart', next);
        store.commit('speedRun', next);
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_left', false);
  _event2.default.up({ key: 'left' });
};

exports.default = { down: down, up: up };

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(11);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_pause', true);
  _event2.default.down({
    key: 'p',
    once: true,
    callback: function callback() {
      var state = store.state;
      if (state.lock) return;
      if (state.snake !== null) {
        _states2.default.pause(!state.pause);
      } else {
        _states2.default.start();
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_pause', false);
  _event2.default.up({ key: 'p' });
};

exports.default = { down: down, up: up };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(11);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_reset', true);
  if (store.state.lock) return;
  if (store.state.snake !== null) {
    _event2.default.down({
      key: 'r',
      once: true,
      callback: function callback() {
        _states2.default.overStart(true);
      }
    });
  } else {
    _event2.default.down({
      key: 'r',
      once: true,
      callback: function callback() {
        if (store.state.lock) return;
        _states2.default.start();
      }
    });
  }
};

var up = function up(store) {
  store.commit('key_reset', false);
  _event2.default.up({ key: 'r' });
};

exports.default = { down: down, up: up };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _snake = __webpack_require__(16);

var _event = __webpack_require__(11);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(12);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_right', true);
  _event2.default.down({
    key: 'right',
    begin: 150,
    interval: 80,
    callback: function callback() {
      var state = store.state;
      if (state.lock) return;
      if (state.snake && state.status === 'playing') {
        if (state.pause) {
          _states2.default.pause(false);return;
        }
        if (_music.music.move) _music.music.move();
        store.commit('snake', (0, _snake.setDirection)(state.snake, _const.DIR.RIGHT));
      } else {
        var next = state.speedStart === 5 ? 0 : state.speedStart + 1;
        store.commit('speedStart', next);
        store.commit('speedRun', next);
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_right', false);
  _event2.default.up({ key: 'right' });
};

exports.default = { down: down, up: up };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _snake = __webpack_require__(16);

var _event = __webpack_require__(11);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(8);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(12);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var downFn = function downFn(store) {
  store.commit('key_up', true);
  _event2.default.down({
    key: 'up',
    begin: 150,
    interval: 80,
    callback: function callback() {
      var state = store.state;
      if (state.lock) return;
      if (state.snake && state.status === 'playing') {
        if (state.pause) {
          _states2.default.pause(false);return;
        }
        if (_music.music.move) _music.music.move();
        store.commit('snake', (0, _snake.setDirection)(state.snake, _const.DIR.UP));
      } else {
        store.commit('wallPass', !state.wallPass);
      }
    }
  });
};

var upFn = function upFn(store) {
  store.commit('key_up', false);
  _event2.default.up({ key: 'up' });
};

exports.default = { down: downFn, up: upFn };

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(36);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__(37);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(61);

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__(15);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(0);

__webpack_require__(60);

var _unit = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _unit.subscribeRecord)(_store2.default);

var initMaxFromCloud = function initMaxFromCloud() {
  if (window.GamePlatform && typeof window.GamePlatform.getMyScores === 'function') {
    window.GamePlatform.getMyScores('greedy-snake', 200).then(function (items) {
      if (items && items.length > 0) {
        var cloudBest = Math.max.apply(Math, (0, _toConsumableArray3.default)(items.map(function (it) {
          return it.score;
        })));
        var localBest = _store2.default.state.max || 0;
        var best = Math.max(cloudBest, localBest);
        if (best > localBest) _store2.default.commit('max', best);
      }
    }).catch(function () {});
  }
};
initMaxFromCloud();

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#root',
  render: function render(h) {
    return h(_App2.default);
  },
  store: _store2.default
});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mutations = {
  snake: function snake(state, data) {
    state.snake = data;
  },
  food: function food(state, data) {
    state.food = data;
  },
  wallPass: function wallPass(state, data) {
    state.wallPass = data;
  },
  matrix: function matrix(state, data) {
    state.matrix = data;
  },
  status: function status(state, data) {
    state.status = data;
  },
  speedStart: function speedStart(state, data) {
    state.speedStart = data;
  },
  speedRun: function speedRun(state, data) {
    state.speedRun = data;
  },
  foodCount: function foodCount(state, data) {
    state.foodCount = data;
  },
  points: function points(state, data) {
    state.points = data;
  },
  max: function max(state, data) {
    state.max = data;
  },
  pause: function pause(state, data) {
    state.pause = data;
  },
  music: function music(state, data) {
    state.music = data;
  },
  reset: function reset(state, data) {
    state.reset = data;
  },
  lock: function lock(state, data) {
    state.lock = data;
  },
  focus: function focus(state, data) {
    state.focus = data;
  },
  key_up: function key_up(state, data) {
    state.keyboard.up = data;
  },
  key_down: function key_down(state, data) {
    state.keyboard.down = data;
  },
  key_left: function key_left(state, data) {
    state.keyboard.left = data;
  },
  key_right: function key_right(state, data) {
    state.keyboard.right = data;
  },
  key_reset: function key_reset(state, data) {
    state.keyboard.reset = data;
  },
  key_music: function key_music(state, data) {
    state.keyboard.music = data;
  },
  key_pause: function key_pause(state, data) {
    state.keyboard.pause = data;
  }
};

exports.default = mutations;

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(152),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(155),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(156),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(150),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(160),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(157),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(153),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(151),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(158),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard",
    style: ('margin-top:' + _vm.fillingNum + 'px')
  }, [_c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 0,
      "left": 374,
      "label": _vm.labelUp,
      "arrow": "translate(0, 63px)",
      "position": true,
      "active": _vm.keyboard['up']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onUpStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onUpStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onUpEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onUpEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onUpEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 180,
      "left": 374,
      "label": _vm.labelDown,
      "arrow": "translate(0,-71px) rotate(180deg)",
      "active": _vm.keyboard['down']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onDownStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onDownStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onDownEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onDownEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onDownEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 284,
      "label": _vm.labelLeft,
      "arrow": "translate(60px, -12px) rotate(270deg)",
      "active": _vm.keyboard['left']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onLeftStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onLeftStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onLeftEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onLeftEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onLeftEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 464,
      "label": _vm.labelRight,
      "arrow": "translate(-60px, -12px) rotate(90deg)",
      "active": _vm.keyboard['right']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onRightStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onRightStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onRightEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onRightEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onRightEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "red",
      "size": "s2",
      "top": 0,
      "left": 196,
      "label": _vm.labelResetR,
      "active": _vm.keyboard['reset']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onResetDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onResetDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onResetUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onResetUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onResetUp.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 106,
      "label": _vm.labelSoundS,
      "active": _vm.keyboard['music']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onMusicDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onMusicDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onMusicUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onMusicUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onMusicUp.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 16,
      "label": _vm.labelPauseP,
      "active": _vm.keyboard['pause']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onPauseDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onPauseDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onPauseUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onPauseUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onPauseUp.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s0",
      "top": 100,
      "left": 52,
      "label": 'GO',
      "active": false
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onGoDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onGoDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onGoUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onGoUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onGoUp.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg pause",
    class: {
      'c': _vm.showPause
    }
  })
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decorate"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topBorder"
  }, [_c('span', {
    staticClass: "l mr",
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml",
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view l"
  }, [_c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  })])
}]}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg music",
    class: _vm.data ? '' : 'c'
  })
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    style: (_vm.size)
  }, [_c('div', {
    staticClass: "rect",
    class: _vm.reset ? 'drop' : ''
  }, [_c('Decorate'), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('Matrix', {
    attrs: {
      "propMatrix": _vm.matrix
    }
  }), _vm._v(" "), _c('Logo', {
    attrs: {
      "cur": _vm.status === 'playing',
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('Point', {
    attrs: {
      "cur": _vm.status === 'playing',
      "max": _vm.max,
      "point": _vm.points
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.foodLabel))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.foodCount
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.wallPassLabel))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.wallPass ? 1 : 0,
      "length": 1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.levelLabel))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.speedRun + 1,
      "length": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Music', {
    attrs: {
      "data": _vm.music
    }
  }), _vm._v(" "), _c('Pause', {
    attrs: {
      "data": _vm.pause
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "propTime": true
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('Keyboard', {
    attrs: {
      "filling": _vm.filling,
      "wallPass": _vm.wallPass
    }
  }), _vm._v(" "), _c('Guide')], 1)
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobile),
      expression: "!isMobile"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "guide left"
  }, [_c('p', [_c('a', _vm._b({
    attrs: {
      "href": "https://github.com/Binaryify/vue-tetris",
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, 'a', {
    title: _vm.linkTitle
  }, false), [_vm._v(_vm._s(_vm.github) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "transform": "scale(1.68)",
      "transform-origin": "center left"
    },
    attrs: {
      "src": "https://ghbtns.com/github-btn.html?user=Binaryify&repo=vue-tetris&type=star&count=true",
      "frameBorder": "0",
      "scrolling": "0",
      "width": "170px",
      "height": "20px"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "transform": "scale(1.68)",
      "transform-origin": "center left"
    },
    attrs: {
      "src": "https://ghbtns.com/github-btn.html?user=Binaryify&repo=vue-tetris&type=fork&count=true",
      "frameBorder": "0",
      "scrolling": "0",
      "width": "170px",
      "height": "20px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_vm._v("SPACE")])]), _vm._v(" "), _c('div', {
    staticClass: "guide qr"
  }, [_c('img', _vm._b({
    attrs: {
      "src": _vm.QRSrc
    }
  }, 'img', {
    title: _vm.QRTitle,
    alt: _vm.QRCode
  }, false))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide right"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(0,-3px) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(-7px,3px) rotate(-90deg) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(0,9px) rotate(180deg) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(7px,3px)rotate(90deg) scale(1,2)"
    }
  })])])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button",
    class: _vm.color + ' ' + _vm.size,
    style: ('top:' + _vm.top + 'px;' + 'left:' + _vm.left + 'px')
  }, [_c('i', {
    class: {
      'active': _vm.active
    }
  }), _vm._v(" "), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.size === 's1'),
      expression: "size==='s1'"
    }],
    style: ('transform:' + _vm.arrow + ' scale(1,2)')
  }), _vm._v(" "), _c('span', {
    class: _vm.position ? 'position' : ''
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matrix"
  }, _vm._l((_vm.propMatrix), function(row, idx) {
    return _c('p', {
      key: idx
    }, _vm._l((row), function(cell, jdx) {
      return _c('b', {
        key: jdx,
        class: cell === 1 ? 'c' : cell === 2 ? 'd' : ''
      })
    }), 0)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.number
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('span', {
      class: 'bg s_' + item
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo",
    style: ('display:' + _vm.display)
  }, [_c('div', {
    staticClass: "bg dragon",
    class: _vm.style
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleCenter)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, exports) {

module.exports = {"lan":["cn","en","fr","fa"],"default":"cn","data":{"title":{"cn":"贪吃蛇","en":"S N A K E","fr":"S E R P E N T","fa":"مار"},"github":{"cn":"GitHub","en":"GitHub","fr":"GitHub","fa":"گیت‌هاب"},"linkTitle":{"cn":"查看源代码","en":"View data source","fr":"Afficher la source des données","fa":"مشاهده سورس پروژه"},"QRCode":{"cn":"二维码","en":"QR code","fr":"QR code","fa":"کیوآر کد"},"QRNotice":{"cn":"扫一扫用手机玩","en":"Scan QR code to play with a mobile phone","fr":"Numérisez le code QR pour jouer avec un téléphone mobile","fa":"اسکن کیوآر کد برای بازی در تلفن همراه"},"titleCenter":{"cn":"贪吃蛇<br />SNAKE","en":"SNAKE","fr":"SERPENT","fa":"مار"},"point":{"cn":"得分","en":"Point","fr":"Score","fa":"امتیاز"},"highestScore":{"cn":"最高分","en":"Max","fr":"Max","fa":"حداکثر"},"lastRound":{"cn":"上轮得分","en":"Last Round","fr":"Dernier Tour","fa":"آخرین دور"},"foodCount":{"cn":"食物数","en":"Food","fr":"Nourriture","fa":"غذا"},"level":{"cn":"级别","en":"Level","fr":"Difficulté","fa":"سطح"},"difficulty":{"cn":"难度","en":"Difficulty","fr":"Difficulté","fa":"سختی"},"wallPass":{"cn":"穿墙","en":"Wall Pass","fr":"Traverser","fa":"عبور از دیوار"},"next":{"cn":"穿墙","en":"Wall Pass","fr":"Traverser","fa":"عبور از دیوار"},"pause":{"cn":"暂停","en":"Pause","fr":"Pause","fa":"مکث"},"sound":{"cn":"音效","en":"Sound","fr":"Sonore","fa":"صدا"},"reset":{"cn":"重玩","en":"Reset","fr":"Réinitialiser","fa":"ریست"},"rotation":{"cn":"旋转","en":"Rotation","fr":"Rotation","fa":"چرخش"},"left":{"cn":"左移","en":"Left","fr":"Gauche","fa":"چپ"},"right":{"cn":"右移","en":"Right","fr":"Droite","fa":"راست"},"down":{"cn":"下移","en":"Down","fr":"Bas","fa":"پایین"},"drop":{"cn":"掉落","en":"Drop","fr":"Tomber","fa":"سقوط"}}}

/***/ })
],[79]);


// WEBPACK FOOTER //
// static/js/app.e0540f0ea9414f91a416.js